import { render, staticRenderFns } from "./DefaultRegionModal.vue?vue&type=template&id=c920712e&scoped=true"
import script from "./DefaultRegionModal.vue?vue&type=script&lang=js"
export * from "./DefaultRegionModal.vue?vue&type=script&lang=js"
import style0 from "./DefaultRegionModal.vue?vue&type=style&index=0&id=c920712e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c920712e",
  null
  
)

export default component.exports